import { queryClient } from "@provider/query-client";
import { toast } from "@provider/toast";
import type { Account } from "@type/account";

// Uitkomst van een machtiging (Mollie): "ok"/"fout" komen van de server
// (deeplink de-grote-verleiding://machtiging?status=… of
// /app/account?machtiging=…), "gesloten" = de klant sloot de browser zelf,
// "doorgestuurd" = (web) dit tabblad gaat naar Mollie en komt later terug.
// De uitkomst bepaalt alleen de melding; wat er echt staat, komt uit het
// opnieuw opgehaalde profiel.
export type MandateResult = "ok" | "fout" | "gesloten" | "doorgestuurd";

export function parseMandateStatus(status: unknown): "ok" | "fout" | null {
  if (status === "ok") {
    return "ok";
  }
  if (status === "fout") {
    return "fout";
  }
  return null;
}

export function showMandateResult(result: MandateResult) {
  if (result === "ok") {
    toast.show("Je bank is gekoppeld");
  } else if (result === "fout") {
    toast.show("Koppelen is niet gelukt, probeer het opnieuw");
  }
}

// finishMandate haalt na de machtiging het profiel opnieuw op (wat er echt
// staat: de webhook kan de machtiging al opgeslagen hebben) en toont de
// melding. Sloot de klant de browser zelf ("gesloten"), bijvoorbeeld omdat
// hij op iOS de vraag "Openen in DeGroteVerleiding?" weigerde, dan melden we
// het koppelen alsnog als de machtiging nu in het profiel staat; anders geen
// melding (de webhook kan nog onderweg zijn).
export async function finishMandate(result: MandateResult): Promise<void> {
  try {
    await queryClient.refetchQueries({ queryKey: ["account"], type: "active" });
  } catch (e) {
    console.log("machtiging: profiel ophalen", e);
  }
  if (result !== "gesloten") {
    showMandateResult(result);
    return;
  }
  const linked = queryClient
    .getQueriesData<Account>({ queryKey: ["account"], type: "active" })
    .some(([, account]) => !!account?.pay_with_sepa);
  if (linked) {
    showMandateResult("ok");
  }
}
